"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PaginationLinks_1 = require("./PaginationLinks");
exports.PaginationLinks = PaginationLinks_1.default;
//# sourceMappingURL=index.js.map